import { lightTokens, darkTokens, type TokenSet } from '@inform-groundstar-shared-platform/shared-design-system';
import type { ThemeDefinition } from 'vuetify';

// Mirrors the design system's MUI palette so this MFE and any MUI shells share one brand source.
// The DS ships resolved colour values, which Vuetify needs for its rgba math. Medium-emphasis text
// and borders stay approximate: Vuetify derives them as an opacity of on-surface where the DS ships
// explicit tokens; the CSS-var layer supplies the exact ones.
function toVuetifyTheme(tokens: TokenSet, dark: boolean): ThemeDefinition {
  return {
    dark,
    colors: {
      background: tokens['surface-app-bg'],
      surface: tokens['surface-elevated'],
      'surface-light': tokens['surface-overlay'],
      'surface-bright': tokens['surface-overlay'],
      'surface-variant': tokens['surface-sunken'],
      'on-surface-variant': tokens['text-understated'],
      primary: tokens['color-primary'],
      'primary-darken-1': tokens['color-primary-hover'],
      secondary: tokens['color-secondary'],
      'secondary-darken-1': tokens['color-secondary-hover'],
      error: tokens['color-danger'],
      info: tokens['color-primary'],
      success: tokens['color-success'],
      warning: tokens['color-warning'],
      'on-primary': tokens['color-primary-contrast'],
      'on-secondary': tokens['color-secondary-contrast'],
      'on-error': tokens['color-danger-contrast'],
      'on-info': tokens['color-primary-contrast'],
      'on-success': tokens['color-success-contrast'],
      'on-warning': tokens['color-warning-contrast'],
      'on-surface': tokens['text-default'],
      'on-background': tokens['text-default'],
    },
    // No border colour: Vuetify's `--v-border-color` must be an "r,g,b" triple (it feeds
    // rgba(var(--v-border-color), var(--v-border-opacity))), so a hex token cannot go here.
  };
}

export const vuetifyTheme = {
  defaultTheme: 'light',
  themes: {
    light: toVuetifyTheme(lightTokens, false),
    dark: toVuetifyTheme(darkTokens, true),
  },
};
